module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "panel-block flex-space-between"
  }, [_c('section', [_c('router-link', {
    attrs: {
      "to": '/videos/' + _vm.id
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.cycleTitle) ? _c('p', [_c('small', [_vm._v("in")]), _vm._v(" " + _vm._s(_vm.cycleTitle))]) : _vm._e()], 1), _vm._v(" "), (!_vm.videoContainsFile) ? _c('input', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button",
      "value": "Copy To"
    },
    on: {
      "click": function($event) {
        _vm.addtoVideo(_vm.id)
      }
    }
  }) : _c('input', {
    staticClass: "button is-warning",
    attrs: {
      "disabled": _vm.videoContainsFile,
      "type": "button",
      "value": "Already Added"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-538d01d7"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoModalVideo.vue
// module id = 1038
// module chunks = 0